export default "__VITE_ASSET__B75oo8C0__"